import { useTranslation } from "react-i18next";
import type { DefinitionProblem } from "../../../api/content/authoring/processAuthoringApi";
import { definitionProblemText } from "../../../errors/definitionProblems";
import { problemsAt, type DefinitionCheck } from "./useDefinitionCheck";

/**
 * The server's problems for one field, shown next to it (AU-3). `id` lets the field name
 * this text with `aria-describedby`.
 */
export default function FieldProblems({ check, path, id }: { check: DefinitionCheck; path: string; id?: string }) {
  const { t } = useTranslation();
  const problems: readonly DefinitionProblem[] = check.status === "checked" ? problemsAt(check.problems, path) : [];
  if (problems.length === 0) {
    return null;
  }
  return (
    <ul id={id} className="app-error-text space-y-0.5 text-xs">
      {problems.map((problem) => (
        <li key={`${problem.path} ${problem.message}`}>{definitionProblemText(problem, t)}</li>
      ))}
    </ul>
  );
}
